import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", null, [
    _withDirectives(_createElementVNode("select", {
      class: "languageDropdown",
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeLanguage($event.target.value))),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentLanguage) = $event))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allLanguages, (language) => {
        return (_openBlock(), _createElementBlock("option", {
          key: language.value,
          value: language.value
        }, _toDisplayString(language.caption), 9 /* TEXT, PROPS */, _hoisted_1))
      }), 128 /* KEYED_FRAGMENT */))
    ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
      [_vModelSelect, _ctx.currentLanguage]
    ])
  ]))
}